import { useMutation } from '@tanstack/react-query';

import { sendNotification, type SendNotificationPayload } from '@services/notification/notification.service';

export function useSendNotification(accessToken: string) {
  return useMutation({
    mutationFn: (payload: SendNotificationPayload) => sendNotification(payload, accessToken),
  });
}
